/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ISubscriptionsMinicartViewProps } from './subscriptions-minicart';

export default ({
    bottleCountComponent,
    editBoxComponent,
    cartDisplaySummaryComponent,
    subscriptionBannerDisplayComponent
}: ISubscriptionsMinicartViewProps) => {
    return (
        <div className='subscription-minicart'>
            <div className='subscription-minicart-header'>
                {subscriptionBannerDisplayComponent}
            </div>
            <div className='subscription-minicart-content'>
                {bottleCountComponent}
                <div className='subscription-minicart-summary-group'>
                    {editBoxComponent}
                    {cartDisplaySummaryComponent}
                </div>
            </div>
        </div>
    );
};
